import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { InfoMessage, PopOutChart } from 'sharedComponents';
import { chartPlugins } from './constants';
import useChartConfig from './useChartConfig';

const EnergyAnomalyChart = ({
    loadingStatus,
    energyAnomalyKPI,
    assetDetails,
    mainChartHeader,
    chartRef,
    actions,
    conditionTrendsData,
    title,
    isZoomed,
    containerRef,
    chartHeight,
    releventSignalsButton,
}) => {
    const [chartInstance, setChartInstance] = useState(null);

    const graphOptions = useChartConfig(
        energyAnomalyKPI,
        title,
        assetDetails,
        conditionTrendsData,
        containerRef,
        chartInstance,
        chartHeight
    );
    const resetServerZoom = () => {
        actions?.reloadConditionInsights(assetDetails?.id);
    };

    const popOutFooterWrapper = releventSignalsButton
        ? <div className='relevent-signals-popout-wrapper'>{releventSignalsButton}</div>
        : null;

    return (
        <>
            <PopOutChart
                hasKpi={!!energyAnomalyKPI?.key}
                renderNoKpi={() => <InfoMessage
                    title='ABB.Powertrain.Frontend.chartNoKPIsSelected'
                    text='ABB.Powertrain.Frontend.chartNoKPIsSelectedUserGuide' />}
                hasData={!!conditionTrendsData?.length}
                renderNoData={() => <InfoMessage
                    title='ABB.Powertrain.Frontend.chartNoMeasurementData'
                    text='ABB.Powertrain.Frontend.chartNoMeasurementDataUserGuide' />}
                enableUniqueScaling={false}
                isZoomed={isZoomed}
                resetServerZoom={resetServerZoom}
                setIsZoomed={actions?.setIsZoomed}
                loadingStatus={loadingStatus}
                options={graphOptions}
                modules={chartPlugins}
                container={'energy-anomaly-chart'}
                mainChartHeader={mainChartHeader}
                chartRef={chartRef}
                onChartReady={setChartInstance}
                chartInstance={chartInstance}
                popOutFooter={popOutFooterWrapper}
            />
            {popOutFooterWrapper}
        </>
    );
};

EnergyAnomalyChart.propTypes = {
    loadingStatus: PropTypes.string,
    energyAnomalyKPI: PropTypes.object,
    assetDetails: PropTypes.object,
    mainChartHeader: PropTypes.elementType,
    chartRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.any })
    ]),
    actions: PropTypes.shape({
        reloadConditionInsights: PropTypes.func,
        setIsZoomed: PropTypes.func
    }),
    conditionTrendsData: PropTypes.array,
    title: PropTypes.string,
    isZoomed: PropTypes.bool,
    containerRef: PropTypes.shape({ current: PropTypes.any }),
    chartHeight: PropTypes.number,
    releventSignalsButton: PropTypes.node,
};

export default EnergyAnomalyChart;
